module.exports = "https://static.energy5.com/_next/static/images/expert-2ad145abc58e658019ceb230f8572718.png";